import React from 'react';

const RW = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_52"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_52)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="#FBD400"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 11H21V15H0V11Z"
        fill="#1D613C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H21V7H0V0Z"
        fill="#00A0E1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.974 3.974C17.57 3.908 18 3.72 18 3.5C18 3.28 17.57 3.092 16.974 3.026C16.908 2.43 16.72 2 16.5 2C16.28 2 16.092 2.43 16.026 3.026C15.43 3.092 15 3.28 15 3.5C15 3.72 15.43 3.908 16.026 3.974C16.092 4.57 16.28 5 16.5 5C16.72 5 16.908 4.57 16.974 3.974Z"
        fill="#FBD400"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default RW;
